<template>
  <base-modal
    ref="modal"
    class="edit-features-modal"
    :image="require('../../../../images/modal/edit-features-graphics.svg')"
    :scrollable="true"
    :show-close-button="false"
    :title="title"
    @submit="updateCompanyFeatures"
  >
    <template #content>
      <div class="container">
        <div class="row d-flex">
          <div class="col">
            <text-input
              :disabled="true"
              label="Company Name"
              :min-width="510"
              :value="companyName"
            />
          </div>
        </div>
        <div class="row d-flex pt-4">
          <div class="col">
            <div class="form-group">
              <rich-input-dropdown
                v-model:value="selectedFeatures"
                :height="290"
                icon="search"
                :clear-on-select="false"
                label="Select feature"
                :display-tags="false"
                :max-displayed="null"
                :max-height="235"
                :options="availableFeaturesOptions"
                placeholder="Search"
                :single="false"
                track-by="title"
                track-label="title"
              >
                <template #single-option-preview></template>
                <template #option-row="option">
                  <template v-if="option.option.title.startsWith('module')">
                    <icon
                      v-if="!!getIconName(option.option.title.split(':')[1])"
                      class="module-icon"
                      style="margin-left:10px;"
                      :name="getIconName(option.option.title.split(':')[1])"
                    />
                    <span class="option__desc">
                      {{
                        getModuleName(option.option.title)
                      }}
                    </span>
                  </template>
                  <template v-else>
                    <span style="margin-left:10px;">{{ option.option.title }}</span><span style="font-size: 0.75em"> – Type: {{
                      option.option.type
                    }}</span>
                  </template>
                </template>
              </rich-input-dropdown>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #actions>
      <div class="container">
        <div class="row d-flex justify-content-sm-between align-content-center">
          <div class="column d-flex  justify-content-center align-content-center">
          </div>
          <div class="column">
            <div class="row">
              <base-button
                size="xl"
                @click.prevent="modal.close"
              >
                Cancel
              </base-button>
              <primary-button
                size="xl"
                @click="updateCompanyFeatures"
              >
                Save
              </primary-button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </base-modal>
</template>

<script>
import { Form } from "@/classes/form"
import { mapActions, mapState } from "vuex"
import Language from "../../../i18n/en"
import RichInputDropdown from "../dropdown/RichInputDropdown"
import Utils from "../../../utils"
import { startCase } from "lodash/string"
import { CompanyRoutes } from "../../../api/routes"

export default {
  components: {
    RichInputDropdown
  },
  props: {
    companyName: {
      type: String,
      required: true
    },
    companyUuid: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: "Edit features"
    },
    action: {
      type: Function,
      default: null
    }
  },
  data () {
    return {
      modal: {
        close: () => {}
      },
      selectedFeatures: [],
      form: new Form({
        name: "",
        features: []
      })
    }
  },
  computed: {
    availableFeaturesOptions () {
      return this.allFeatures.map(this.mapFeatureKeyMapToObject)
    },
    ...mapState(["allFeatures", "availableFeatures"])
  },
  mounted () {
    this.modal = this.$refs.modal

    this.loadAllFeatures()
    this.loadObjectFeatures(this.companyUuid)
      .then(() => {
        this.selectedFeatures = this.availableFeatures.map((featureKey) => {
          return {
            title: featureKey,
            type: this.mapFeatureKeyMapToObject(featureKey)
          }
        })
      })
  },
  methods: {
    mapFeatureKeyMapToObject (f) {
      let type = "Global"
      switch (f.split(":")[0]) {
        case "fe":
          type = "Frontend"
          break
        case "be":
          type = "Backend"
          break
        case "gr":
          type = "Grouped"
          break
        case "module":
          type = "Module"
          break
      }
      return {
        title: f,
        type
      }
    },
    updateCompanyFeatures () {
      this.form.features = this.selectedFeatures.map(f => f.title)
      this.form.name = this.companyName

      return this.form
        .put(CompanyRoutes.updateCompany(this.companyUuid))
        .then(this.onSuccess)
        .catch(() => {
          this.$toasted.error(Language.company.error.edit_features)
        })
    },
    onSuccess () {
      this.$toasted.success(Language.company.success.edit_features)
      this.modal.close()
      if (this.action) {
        this.action()
      }
    },
    getIconName (type = null) {
      return Utils.getModuleIconName(type !== null ? type : "")
    },
    getModuleName (moduleString) {
      const moduleNameString = startCase(moduleString.split(":")[1])
      return moduleNameString.split("Module")[0].charAt(0).toUpperCase() + moduleNameString.split("Module")[0].slice(1)
    },
    ...mapActions(["loadAllFeatures", "loadObjectFeatures"])
  }
}
</script>
